/* =============================================================
   BUNDLE BUILDER — UNIFIED PATCH  v4.0
   =============================================================
   Includes:
     1. Klaviyo popup suppression
     2. MARCHE selector bar (original)
     3. Responsive CSS fixes (desktop + mobile)
        – MARCH letters MUCH brighter (opacity 0.92 on mobile)
        – Mobile CTA centered (flex-direction: column)
        – Compact 4:3 cards
        – White background on product card images (transparent PNG fix)
     4. Slider cart flash fix (no transition on initial paint)
     5. Discount guard v3.1
   ============================================================= */

(function(){"use strict";function nukeKlaviyo(){document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"],[data-testid="POPUP"],div[class*="kl-teaser"]').forEach(function(el){el.style.setProperty("display","none","important"),el.style.setProperty("visibility","hidden","important"),el.style.setProperty("pointer-events","none","important")}),document.body.classList.remove("klaviyo-prevent-body-scrolling"),document.body.style.removeProperty("overflow")}var klObserver=new MutationObserver(function(mutations){for(var i=0;i<mutations.length;i++){var m=mutations[i];if(m.addedNodes.length)for(var j=0;j<m.addedNodes.length;j++){var node=m.addedNodes[j];node.nodeType===1&&node.getAttribute&&(node.getAttribute("role")==="dialog"&&(node.getAttribute("aria-label")||"").indexOf("POPUP")!==-1||typeof node.className==="string"&&node.className.indexOf("kl-teaser")!==-1)&&nukeKlaviyo()}m.type==="attributes"&&m.target===document.body&&document.body.classList.contains("klaviyo-prevent-body-scrolling")&&nukeKlaviyo()}});klObserver.observe(document.documentElement,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["class"]}),nukeKlaviyo(),document.addEventListener("DOMContentLoaded",nukeKlaviyo),setTimeout(nukeKlaviyo,500),setTimeout(nukeKlaviyo,1500),setTimeout(nukeKlaviyo,3e3),setTimeout(nukeKlaviyo,6e3),setTimeout(nukeKlaviyo,1e4);var MARCHE_CONFIG={pouch:{label:"IFAK Pouch",letter:null,color:"#9c8f61",colorLight:"rgba(156,143,97,0.12)"},M:{label:"Massive Hemorrhage",letter:"M",color:"#c62828",colorLight:"rgba(198,40,40,0.10)"},A:{label:"Airway",letter:"A",color:"#43a047",colorLight:"rgba(67,160,71,0.10)"},R:{label:"Respiration",letter:"R",color:"#1e88e5",colorLight:"rgba(30,136,229,0.10)"},C:{label:"Circulation",letter:"C",color:"#757575",colorLight:"rgba(117,117,117,0.10)"},H:{label:"Head/Hypothermia",letter:"H",color:"#7b1fa2",colorLight:"rgba(123,31,162,0.10)"},E:{label:"Everything Else",letter:"E",color:"#f57c00",colorLight:"rgba(245,124,0,0.10)"}},GROUP_ORDER=["pouch","M","A","R","C","H","E"];window.__MARCHE_CONFIG=MARCHE_CONFIG;window.__GROUP_ORDER=GROUP_ORDER})();

/* === BB Responsive Fixes v2.0 — Brighter MARCH Letters + Slider Cart Flash Fix === */
;(function(){
  var s=document.createElement('style');
  s.id='bb-responsive-fix';
  s.textContent=
    /* ── Slider Cart Flash Fix ────────────────────────────────── */
    /* Hide drawer by default with visibility:hidden so the transition */
    /* doesn't play on initial page load (the "flash" bug). */
    '#slider-cart-drawer.sc-drawer{' +
      'visibility:hidden !important;' +
    '}' +
    '#slider-cart-drawer.sc-drawer.sc-drawer--open{' +
      'visibility:visible !important;' +
    '}' +
    /* Also ensure overlay is truly hidden until toggled */
    '#slider-cart-overlay{' +
      'visibility:hidden !important;' +
    '}' +
    '#slider-cart-overlay.sc-overlay--visible{' +
      'visibility:visible !important;' +
    '}' +

    /* ── DESKTOP / BASE (all viewports) ──────────────────────── */
    '.bb-selector-tab{padding:12px 22px !important;gap:3px !important}' +

    /* MARCH letters — much brighter: bump opacity to 0.88 on desktop */
    '.bb-selector-tab__letter{font-size:22px !important;opacity:0.88 !important}' +
    '.bb-selector-tab.is-active .bb-selector-tab__letter{opacity:1 !important}' +

    /* Tab labels — brighter warm-grey */
    '.bb-selector-tab__label{font-size:11.5px !important;color:#d5d2c9 !important;opacity:1 !important}' +
    '.bb-selector-tab:not(.is-active) .bb-selector-tab__label{color:#d5d2c9 !important;opacity:1 !important}' +
    '.bb-selector-tab.is-active .bb-selector-tab__label{color:#ffffff !important;opacity:1 !important}' +

    /* Card images — 4:3, white bg, contain (no crop) */
    '.bb-card__img-wrap{aspect-ratio:4/3 !important;background:#ffffff !important;overflow:hidden !important}' +
    '.bb-card__img-wrap img{background:#ffffff !important;object-fit:contain !important;width:100% !important;height:100% !important}' +

    /* ── MOBILE OVERRIDES (767px and below) ──────────────────── */
    '@media(max-width:767px){' +

      '.bb-selector-bar{padding:4px 0}' +
      '.bb-selector-tab{padding:10px 16px !important;min-width:72px}' +

      /* MARCH letters — MUCH brighter on mobile: 0.92 opacity */
      '.bb-selector-tab__letter{font-size:18px !important;opacity:0.92 !important}' +
      '.bb-selector-tab.is-active .bb-selector-tab__letter{opacity:1 !important}' +

      /* Tab labels — brighter on mobile too */
      '.bb-selector-tab__label{font-size:10.5px !important;color:#dbd8d0 !important}' +
      '.bb-selector-tab:not(.is-active) .bb-selector-tab__label{color:#d5d2c9 !important}' +

      /* Compact card body */
      '.bb-card__body{padding:6px 8px 8px !important}' +
      '.bb-card__title{font-size:11.5px !important;margin-bottom:3px !important;line-height:1.3 !important}' +
      '.bb-card__variant-swatch{width:18px !important;height:18px !important}' +
      '.bb-card__variants{margin-bottom:4px !important;gap:3px !important}' +
      '.bb-card__price{margin-bottom:5px !important}' +
      '.bb-card__price-current{font-size:12px !important}' +
      '.bb-card__price-compare{font-size:10px !important}' +
      '.bb-card__add-btn{padding:5px 8px !important;font-size:10px !important}' +
      '.bb-card__qty{height:28px !important}' +
      '.bb-card__qty-btn{width:28px !important;height:28px !important;font-size:16px !important}' +
      '.bb-card__qty-num{font-size:12px !important}' +
      '.bb-grid{gap:8px !important}' +

      /* ── Compact mobile bar CTA (row layout, under 60px) ──── */
      '.bb-mobile-bar{' +
        'display:flex !important;' +
        'flex-direction:row !important;' +
        'align-items:center !important;' +
        'justify-content:space-between !important;' +
        'gap:10px !important;' +
        'padding:8px 12px !important;' +
        'padding-bottom:calc(8px + env(safe-area-inset-bottom)) !important;' +
      '}' +
      '.bb-mobile-bar__info{' +
        'display:flex !important;' +
        'flex-direction:column !important;' +
        'align-items:flex-start !important;' +
        'gap:1px !important;' +
        'flex:1 !important;' +
        'width:auto !important;' +
      '}' +
      '.bb-mobile-bar__btn{' +
        'flex:none !important;' +
        'width:auto !important;' +
        'max-width:none !important;' +
        'padding:8px 16px !important;' +
        'font-size:11px !important;' +
        'white-space:nowrap !important;' +
        'margin:0 !important;' +
        'float:none !important;' +
      '}' +

    '}' +

    /* Extra small screens */
    '@media(max-width:380px){' +
      '.bb-selector-tab{padding:8px 12px !important;min-width:64px}' +
      '.bb-selector-tab__letter{font-size:16px !important;opacity:0.92 !important}' +
      '.bb-selector-tab__label{font-size:9.5px !important}' +
    '}';

  document.head.appendChild(s);
})();

/* ===========================================================
   BUNDLE BUILDER — ADD TO CART GUARD  v3.2
   ===========================================================
   Clone-replaces the ATC buttons to strip the original
   click listener, reads items from the product grid, adds
   them to cart via /cart/add.js, then opens the cart drawer.
   Discount is handled by the Fudge engine via _fudge tokens.
   =========================================================== */
;(function () {
  'use strict';

  /* --- helpers ------------------------------------------------ */

  function pctForQty(qty) {
    if (qty >= 10) return 10;
    if (qty >= 7) return 7;
    if (qty >= 5) return 5;
    return 0;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCart() {
    var trigger = document.querySelector(
      '[data-cart-drawer-trigger],.cart-drawer__toggle,.js-drawer-open-cart'
    );
    if (trigger) trigger.click();
    else window.location.href = '/cart';
  }

  function showToast(msg) {
    var t = document.getElementById('bb-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
  }

  /* --- read bundle items from the product grid --------------- */

  function readGridItems() {
    var items = [];
    var cards = document.querySelectorAll('.bb-card');
    cards.forEach(function (card) {
      var numEl = card.querySelector('.bb-card__qty-num');
      var qty = numEl ? parseInt(numEl.textContent, 10) : 0;
      if (qty < 1) return;

      var btn = card.querySelector('[data-variant-id]');
      if (!btn) return;
      var vid = parseInt(btn.dataset.variantId, 10);
      if (!vid) return;

      items.push({ id: vid, quantity: qty });
    });
    return items;
  }

  /* --- guarded add-to-cart ----------------------------------- */

  function guardedAddToCart(e) {
    e.stopImmediatePropagation();
    e.preventDefault();

    var btn = e.currentTarget;
    if (btn.disabled) return;

    var gridItems = readGridItems();
    if (gridItems.length === 0) {
      showToast('Add at least one item first!');
      return;
    }

    var uniqueCount = gridItems.length;

    var pct = pctForQty(uniqueCount);
    var discountStr = pct > 0 ? pct + '%' : '0%';

    var payload = gridItems.map(function (it) {
      return {
        id: it.id,
        quantity: it.quantity,
        properties: {
          _bundle: 'Build Your Own IFAK',
          _bundle_discount: discountStr
        }
      };
    });

    var origBtnText = btn.textContent;

    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding to cart\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Cart error'); });
      return r.json();
    })
    .then(function () {
      btn.classList.remove('is-loading');
      btn.textContent = '\u2713 Added!';
      btn.style.background = '#2a7c3f';
      showToast('\u2713 Bundle added to cart!');

      setTimeout(function () {
        openCart();
        btn.style.background = '';
        btn.disabled = false;
        btn.textContent = origBtnText;
      }, 800);
    })
    .catch(function (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = origBtnText;
      showToast('Error: ' + err.message);
    });
  }

  /* --- clone-replace to strip original listener -------------- */

  function patchButton(btn) {
    if (!btn || btn.dataset.bbGuarded) return;
    var clone = btn.cloneNode(true);
    clone.dataset.bbGuarded = '1';
    clone.addEventListener('click', guardedAddToCart);
    btn.parentNode.replaceChild(clone, btn);
  }

  function patchAll() {
    patchButton(document.getElementById('bb-atc-btn'));
    patchButton(document.getElementById('bb-drawer-atc-btn'));
  }

  /* --- run after the original IIFE binds its handler --------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(patchAll, 500);
    });
  } else {
    setTimeout(patchAll, 500);
  }

  /* Re-patch if the button is ever recreated dynamically — scoped to class changes only */
  var _bbMoTimer = null;
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class') {
        clearTimeout(_bbMoTimer);
        _bbMoTimer = setTimeout(patchAll, 300);
        break;
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

})();